App.filter('billStatusFilter', function () {
    return function (el) {
        el = el || '';

        var dictionary = [];
        
        dictionary['PAID'] = 'Zapłacono';
        dictionary['NOT_PAID'] = 'Do zapłaty';

        if (el) {
        	if (dictionary[el]) {
        		return dictionary[el];
        	} else {
        		return el;
        	}
        }

        return el;
    };
})